var dynamicRequire = require('../../dynamicRequire');
var React = dynamicRequire('react');
var Select = dynamicRequire('Select.jsx');
var AccordionTab = dynamicRequire('AccordionTab.jsx');
var resolveLanguage = dynamicRequire('resolveLanguage');
var Mssg = dynamicRequire('Mssg.jsx');

class KeyboardChooser extends React.Component {
    constructor(props, context) {
        super(props)

        this.state = {
            tabOpen: !!this.props.case.keyboardBrandAndModel
        }

        context.emitter.on('tabOpen', (group, name)=> {
            if (group == 'customKeyboard' && name == 'customKeyboard') {
                this.setState({
                    tabOpen: true
                })
            }
        })
        context.emitter.on('tabClose', (group, name)=> {
            if (group == 'customKeyboard' && name == 'customKeyboard') {
                this.setState({
                    tabOpen: false
                })
            }
        })
    }

    render() {
        return <div>
            {this.getKeyboardCaseChooser()}
            {this.getCustomKeyboardInput()}
        </div>
    }

    getKeyboardCaseChooser() {
        return <div className="lr-casefactory-choices-keyboard-select keyboard-select">
            <label><Mssg __key="nc_casefactory.keyboard.manufacturer" /></label>
            <Select
                className="lr-style"
                choiceHandler={(value) => {
                    this.context.emitter.emit('manufacturer', value)
            }}
                active={this.props.case.keyboardManufacturer}
                    callToAction={resolveLanguage("nc_casefactory.choose.manufacturer")}
                    showCallToAction={!this.props.case.keyboardManufacturer}
                    options={this.getManufacturers().map(function (manufacturer) {
                        return {value: manufacturer, name: manufacturer}
                    })}/>
            {this.getModels().length ?
                <div>
                    <label><Mssg __key="nc_casefactory.keyboard.model" /></label>
                    <Select
                        className="lr-style"
                        key={this.props.case.keyboardManufacturer}
                        choiceHandler={(value) => {
                            this.context.emitter.emit('keyboard', value)
                        }}
                        showCallToAction={!this.props.case.keyboardId}
                        callToAction={resolveLanguage('nc_casefactory.choose.model')}
                        active={this.props.case.keyboardId}
                        options={this.getModels().map(model => {
                            return {name: model.model, value: model.id}
                        })}/>
                </div>
                : ''}
        </div>
    }

    getCustomKeyboardInput() {
        return <AccordionTab className="lr-casefactory-choices-keyboardcases keyboardcases"
                             open={!!this.props.case.keyboardBrandAndModel || this.state.tabOpen}
                             group='customKeyboard'
                             name='customKeyboard'
                             duration={200}>
            <div className="lr-casefactory-choices-keyboardcases-notfound notfound">
                <Mssg __key="nc_casefactory.did.not.found.keyboard.header" />
            </div>
            <div>
                <label
                    htmlFor="keyboardInput"><Mssg __key="nc_casefactory.keyboards.modelandmanufacturer" /> </label>
                <input type="text" name="keyboardInput" className='lr-casefactory-choices-customkeyboard customkeyboard'
                       onChange={(e) => {
                           this.context.emitter.emit('keyboardBrandAndModelChange', e.target.value)
                       }}
                       onKeyPress={(e) => {
                           if (e.key === 'Enter') {
                               // triggers onBlur (and we only need one event fired...)
                               e.target.blur()
                           }
                       }}
                       onBlur={(e) => {
                           this.context.emitter.emit('keyboardBrandAndModel', e.target.value)
                       }}
                       value={this.props.case.keyboardBrandAndModel || ''}/>
            </div>
        </AccordionTab>
    }

    getModels() {
        return this.props.keyboards.filter(keyboard => {
            return keyboard.manufacturer == this.props.case.keyboardManufacturer
        });
    }

    getManufacturers() {
        return unique(this.props.keyboards.map((keyboard)=> {
            return keyboard.manufacturer;
        })).sort();
    }
}

function unique(array) {
    return array.filter((item, index) => {
        return array.indexOf(item) === index;
    })
}

KeyboardChooser.contextTypes = {
    emitter: React.PropTypes.object.isRequired,
};


module.exports = KeyboardChooser;


// WEBPACK FOOTER //
// ./js/caseconfigurator-ui/lib/components/Dimensions/KeyboardChooser.jsx